import { render, staticRenderFns } from "./NavbarBlock.vue?vue&type=template&id=ea40134c"
import script from "./NavbarBlock.vue?vue&type=script&lang=js"
export * from "./NavbarBlock.vue?vue&type=script&lang=js"
import style0 from "./NavbarBlock.vue?vue&type=style&index=0&id=ea40134c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports